import React, { useState } from 'react';
import {
  Box,
  Stack,
  Stepper,
  Step,
  StepLabel,
  Container,
} from '@mui/material';
import MyTypography from './MyTypography';
import MyButton from './MyButton';

export function MyStepperHeader({ steps, activeStep }) {
  return (
    <Box sx={{ width: '100%' }}>
      <Stepper activeStep={activeStep}>
        {steps.map((step, index) => {
          const stepProps = {};
          const labelProps = {};
          return (
            <Step key={step.label} {...stepProps}>
              <StepLabel {...labelProps}>
                {step.label}
              </StepLabel>
            </Step>
          );
        })}
      </Stepper>
    </Box>
  );
}

export default function MyStepper({
  steps,
  onSubmit,
  backButtonText = 'Back',
  nextButtonText = 'Next',
  submitButtonText = 'Submit',
}) {
  const [activeStep, setActiveStep] = useState(0);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  return (
    <Container maxWidth="sm">
      <Stack spacing={5}>
        <Box>
          <MyStepperHeader activeStep={activeStep} steps={steps} />
        </Box>

        <Stack spacing={3}>
          <MyTypography sx={{ fontSize: '1.4rem', fontWeight: 600 }}>
            Step {activeStep + 1}
          </MyTypography>
          <Box>{steps[activeStep].content}</Box>
        </Stack>

        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
          <MyButton
            color="primary"
            variant="outlined"
            disabled={activeStep === 0}
            onClick={handleBack}
            fullWidth={false}
          >
            {backButtonText}
          </MyButton>
          {activeStep < steps.length - 1 && (
            <MyButton onClick={handleNext} variant="contained" fullWidth={false}>
              {nextButtonText}
            </MyButton>
          )}
          {activeStep === steps.length - 1 && (
            <MyButton onClick={onSubmit} variant="contained" fullWidth={false}>
              {submitButtonText}
            </MyButton>
          )}
        </Box>
      </Stack>
    </Container>
  );
}
